import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../services/api'

const TopInstructorsOne = () => {
    const [instructors, setInstructors] = useState([]);
    const [loading, setLoading] = useState(true);

    // Default user image paths array
    const userImages = [
        "assets/images/users/user1.png",
        "assets/images/users/user2.png",
        "assets/images/users/user3.png",
        "assets/images/users/user4.png",
        "assets/images/users/user5.png"
    ];

    useEffect(() => {
        const fetchInstructors = async () => {
            try {
                // Fetch instructors using the roles API
                const response = await api.roles.getUsersByRole("INSTRUCTOR");
                
                if (response.success) {
                    // Add additional display data to instructors and limit to 6
                    const enhancedInstructors = response.data.slice(0, 6).map((instructor, index) => {
                        return {
                            ...instructor,
                            profileImage: instructor.profileImage || userImages[index % userImages.length],
                            // Random rating between 3 and 5 stars
                            rating: Math.floor(Math.random() * 3) + 3,
                            // Random review count between 10 and 50
                            reviewCount: Math.floor(Math.random() * 41) + 10
                        };
                    });
                    
                    setInstructors(enhancedInstructors);
                }
            } catch (error) {
                console.error('Error fetching instructors:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchInstructors();
    }, []);

    // Function to render star ratings
    const renderStars = (rating) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <span key={i} className="text-lg text-warning-600 d-flex line-height-1">
                    <i className="ri-star-fill" />
                </span>
            );
        }
        return stars;
    };

    return (
        <div className="col-xxl-4 col-md-6">
            <div className="card">
                <div className="card-header">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg mb-0">Top Instructors</h6>
                        <Link
                            to="/users-list"
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                        >
                            View All
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon"
                            />
                        </Link>
                    </div>
                </div>
                <div className="card-body">
                    {loading ? (
                        <div className="text-center py-4">Loading instructors...</div>
                    ) : instructors.length === 0 ? (
                        <div className="text-center py-4">No instructors found</div>
                    ) : (
                        instructors.map((instructor, index) => (
                            <div 
                                key={instructor._id || index} 
                                className={`d-flex align-items-center justify-content-between gap-3 ${index < instructors.length - 1 ? 'mb-24' : ''}`}
                            >
                                <div className="d-flex align-items-center">
                                    <img
                                        src={instructor.profileImage}
                                        alt={`${instructor.firstName} ${instructor.lastName}`}
                                        className="w-40-px h-40-px rounded-circle flex-shrink-0 me-12 overflow-hidden"
                                    />
                                    <div className="flex-grow-1">
                                        <h6 className="text-md mb-0 fw-medium">{`${instructor.firstName} ${instructor.lastName}`}</h6>
                                        <span className="text-sm text-secondary-light fw-medium">
                                            ID: {instructor._id?.substring(0, 6) || `INS${10000 + index}`}
                                        </span>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="d-flex align-items-center gap-6 mb-1">
                                        {renderStars(instructor.rating)}
                                    </div>
                                    <span className="text-primary-light text-sm d-block text-end">
                                        {instructor.reviewCount} Reviews
                                    </span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default TopInstructorsOne;